import { FC } from 'react'

import { IMenu, IMenuFavorite } from '../../../models'
import { CardLink, Icon, Loading, Text } from '../../UI'


type MenuFavoritesSummaryProps = {
  className?: string,
  menu: IMenu[],
  favorites?: IMenuFavorite[] | null,
  style?: any
}

const MenuFavoritesSummary:FC<MenuFavoritesSummaryProps> = ({ className = '', menu = [], favorites = [], style }) => {
  return (
    <div className={`row ${className}`} style={style}>
      {favorites ?
          favorites.map((it, i) => {
            const menuItem = menu.find(it2 => it2.id === it.menu_id)

            if(!menuItem) return null

            return (
              <div key={i} className={`col-4${i === 0 ? ' pr-5' : ''}${i === 1 ? ' px-5' : ''}${i === 2 ? ' pl-5' : ''}`}>
                <CardLink to={menuItem.url}>
                  <div style={{ height: 25 }}>
                    <Icon name={menuItem.icon} />
                  </div>
                  <Text component="span" size="13" className="mt-5">{menuItem.name}</Text>
                </CardLink>
              </div>
            )
          })
        :
          <Loading size="md" align="center" className="w-full mt-20" />
      }
    </div>
  )
}

export { MenuFavoritesSummary }